module.exports = __webpack_public_path__ + "img/header-slash.9e0897b6.svg";